import { Gem, Flame, Zap } from "lucide-react";
import { fmtARS } from "../lib/utils-app";
import { HangingSpider } from "./Halloween";

const PACK_IMG = {
  pkg_110: "/packs/hq1.webp",
  pkg_341: "/packs/hq2.webp",
  pkg_572: "/packs/hq3.webp",
  pkg_1166: "/packs/hq4.webp",
  pkg_2398: "/packs/hq5.webp",
  pkg_6160: "/packs/hq6.webp",
};

export default function PackageCard({ pkg, selected, onSelect }) {
  return (
    <button
      type="button"
      onClick={() => onSelect(pkg)}
      data-testid={`package-card-${pkg.id}`}
      className={`pkg-card group relative w-full min-w-0 rounded-xl p-3 sm:p-5 text-left overflow-hidden ${selected ? "pkg-card--selected" : ""}`}
    >
      <HangingSpider length={pkg.diamonds % 2 ? 28 : 44} side={pkg.diamonds % 3 ? "right" : "left"} />
      <div className="relative h-28 sm:h-36 lg:h-48 mb-3 rounded-lg overflow-hidden border border-white/5">
        <img
          src={PACK_IMG[pkg.id] || "/packs/hq1.webp"}
          alt={`${pkg.diamonds} diamantes`}
          loading="lazy"
          data-testid={`package-img-${pkg.id}`}
          className="w-full h-full object-cover pointer-events-none group-hover:scale-105"
          style={{ transition: "transform 220ms ease" }}
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-br from-transparent via-transparent to-[#ff4500]/10 pointer-events-none" aria-hidden />

      {pkg.bonus && (
        <span className="absolute top-2 left-3 badge-hot text-[10px] px-2 py-0.5 rounded-md tracking-wider z-10">
          {pkg.bonus}
        </span>
      )}
      {pkg.popular && (
        <span className="absolute top-3 right-3 flex items-center gap-1 text-[10px] text-[#ff4500] tracking-widest z-10">
          <Flame className="w-3 h-3" /> POPULAR
        </span>
      )}

      <div className="relative flex items-center gap-2 mb-3">
        <Gem className="w-5 h-5 text-[#ff4500] shrink-0" strokeWidth={2} />
        <div>
          <div className="font-display text-3xl sm:text-4xl leading-none tracking-wider text-white">
            {pkg.diamonds.toLocaleString("es-AR")}
          </div>
          <div className="text-xs text-neutral-400 uppercase tracking-widest">Diamantes</div>
        </div>
      </div>

      <div className="relative flex flex-wrap items-end justify-between gap-2 pt-3 border-t border-white/5">
        <div>
          <div className="text-[10px] uppercase tracking-widest text-neutral-500">Precio</div>
          <div className="text-lg font-bold text-white">{fmtARS(pkg.price_ars)}</div>
        </div>
        <div className={`text-xs px-2 py-1 rounded-md flex items-center gap-1 ${selected ? "bg-[#ff4500] text-black" : "bg-white/5 text-neutral-300"}`}>
          <Zap className="w-3 h-3" /> {selected ? "SELECCIONADO" : "ELEGIR"}
        </div>
      </div>
    </button>
  );
}
